import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { updateCurrentAnswer, updateSaveState } from '../../state/actions/results';
import { setWindowIndex } from '../../state/actions/current-window-index';

export default function HOCViewController (WrappedComponent, data) {

	@connect(
		state => ({
			activeStep: state.step.activeStep.id,
			steps: state.step.steps,
			answers: state.results.answer,
			players: state.setup.players,
			user: state.user,
			translations: state.setup.translations,
		}),
		dispatch => ({
			updateCurrentAnswer: (updatedAnswers) => {
				dispatch(updateCurrentAnswer(updatedAnswers));
			},
			setWindowIndex: (index) => {
				dispatch(setWindowIndex(index));
			},
			updateSaveState: (saveData) => {
				dispatch(updateSaveState(saveData));
			}
		})
	)
	class HOC extends Component {

		static PropTypes = {
			updateCurrentAnswer: PropTypes.func,
			setWindowIndex: PropTypes.func,
			answers: PropTypes.object,
			user: PropTypes.object,
			players: PropTypes.object,
			updateSaveState: PropTypes.func
		};

		/**
		 * @constructor
		 *
		 * @param {Object} props
		 */
		constructor (props) {
			super(props);
		}

		componentWillMount () {
			this.windows = [];
			this.conditionalWindows = [];
			this.setConditionalWindows();

			this.state = {
				window: {
					key: Object.keys(data)[0],
					current: this.windows[0],
					index: 0,
					isLast: 0 === this.windows.length - 1,
					isNextStepDisabled: !!this.windows[0].answers
				},
				currentValue: '',
				updateAnswer: (event) => this.updateAnswer(event),
				nextWindow: () => this.nextWindow(),
				updateSaveState: (saveData) => this.props.updateSaveState(saveData),
				players: this.props.players,
				user: this.props.user.profileData,
				countryCode: this.props.user.profileData.countryCode,
				isLastQuestion: this.findLastQuestionId() === this.props.activeStep,
				isLastStep: this.props.steps[this.props.steps.length - 1].id === this.props.activeStep,
				hasConditionalWindows: !!this.conditionalWindows.length,
				step: this.props.activeStep,
				translations: this.props.translations,
			};

			this.timeStart = Date.now();
			this.props.setWindowIndex(0);
		}

		setConditionalWindows () {
			data.windows.map((window) => {
				if (window.condition) {
					this.conditionalWindows.push(window);
				} else {
					this.windows.push(window);
				}
			});
			this.orignalNonConditionalWindows = [...this.windows];
		}

		findLastQuestionId () {
			const questions = this.props.steps.filter((steps) => {
				return steps.shouldFinish === true;
			});

			return questions[questions.length - 1].id;
		}

		updateAnswer (event) {
			const target = event.currentTarget;
			const value = target && target.value || event.toString();

			if (this.state.hasConditionalWindows) {
				this.applyConditionalWindows(value);
			}

			this.setState((prevState) => {
				return {
					currentValue: value,
					window: {
						...this.state.window,
						isNextStepDisabled: !value,
						isLast: prevState.window.index >= this.windows.length - 1
					}
				}
			},
                () => {
                this.props.updateCurrentAnswer({
                    [this.props.activeStep]: {
                        answer: value,
                        timeStart: this.timeStart
                    }
                });
            });
		}

		applyConditionalWindows (value) {
			this.operationOutcome = this.checkOperation(value)[0];
			this.windows = [...this.orignalNonConditionalWindows, this.operationOutcome];
		}

		checkOperation (value) {
			return this.conditionalWindows.filter((window) => {
				const { operand, operator } = window.condition;
				for (const entry of operand) {
					if (eval(`${value} ${operator} ${entry}`)) {
						return true;
					}
				}
				return false;
			})
		}

		nextWindow () {
			this.setState((prevState) => {
				const newIndex = prevState.window.index + 1;
				const isLast = newIndex >= this.windows.length - 1;
				this.props.setWindowIndex(newIndex);
				return {
					window: {
						key: Object.keys(data)[0],
						current: this.windows[newIndex],
						index: newIndex,
						isLast: isLast,
						isNextStepDisabled: !!this.windows[newIndex].answers
					}
				};
			});
		};

		/**
		 * @TODO: make a go back option for a window, should be the same as the next window function.
		 */
		// prevWindow () {
		// 	this.setState((prevState) => {
		// 		const newIndex = prevState.window.index - 1;
		// 		const isLast = newIndex >= this.windows.length - 1;
		// 		this.props.setWindowIndex(newIndex);
		// 		return {
		// 			window: {
		// 				key: Object.keys(data)[0],
		// 				current: this.windows[newIndex],
		// 				index: newIndex,
		// 				isLast: isLast,
		// 				isNextStepDisabled: !!this.windows[newIndex].answers
		// 			}
		// 		};
		// 	});
		// };

		/**
		 * @description
		 * Component Method
		 * Renders a component
		 *
		 * @returns {ReactElement} component
		 */
		render () {
			return (
				<WrappedComponent {...data } {...this.state} />
			)
		}
	}
	return HOC;
}
